module.exports = __webpack_public_path__ + "static/media/express-delivery.dedbd7a7.svg";